export default {
  props: {
    /**
     * 容器ID。
     */
    domId: {
      type: String,
      default: 'player',
    },
    /**
     * 云点播平台的视频唯一id。
     */
    vid: {
      type: String,
      default: '',
    },
    /**
     * 播放器的宽度，支持像素值和百分比两种方式，如200或100%。
     */
    width: {
      type: [String, Number],
      default: '100%',
    },
    /**
     * 播放器的高度，支持像素值、百分比和自适应三种方式
     * 如100、40%。当值为空时，会根据视频比例自动计算高度。
     */
    height: {
      type: [String, Number],
      default: '100%',
    },
    /**
     * 是否自动播放。
     * 注：目前大多数浏览器都会限制自动播放，该参数可能无效。
     */
    autoStart: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否允许进度条拖动
     */
    dragEnable: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否允许切换倍速
     */
    rateEnable: {
      type: Boolean,
      default: false,
    },
    startTime: {
      type: [String, Number],
      default: 0,
    },
  },
}
